// Тосты с отменой действия (DESIGN.md §4: «ничего не теряется»).
import { useSyncExternalStore } from 'react';

export interface Toast {
  id: number;
  text: string;
  action?: { label: string; run: () => void };
}

let toasts: Toast[] = [];
let seq = 0;
const listeners = new Set<() => void>();
const emit = () => {
  for (const l of listeners) l();
};

export function toast(text: string, action?: Toast['action'], ttl = 5000): void {
  const t: Toast = { id: ++seq, text, ...(action ? { action } : {}) };
  toasts = [...toasts.slice(-2), t];
  emit();
  setTimeout(() => dismissToast(t.id), ttl);
}

export function dismissToast(id: number): void {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => toasts,
    () => toasts,
  );
}
